const styleOverrides = {
  circleDeterminate: {
    strokeLinecap: 'round'
  }
};
export default {
  styleOverrides
};